










import Vue from 'vue'
import AppView from './components/AppView.vue'
import AppDialog from '@/lib/calendesk-js-library/components/dialogs/AppDialog.vue'
import ConfirmDialog from '@/lib/calendesk-js-library/components/confirmDialogs/ConfirmDialog.vue'
import Snackbar from '@/lib/calendesk-js-library/components/Snackbar.vue'
import DialogList from '@/components/dialogs/DialogList'
import confirmDialogList from '@/components/confirmDialogs/confirmDialogList'
import AiAssistant from '@/lib/calendesk-js-library/components/AiAssistant.vue'

export default Vue.extend({
  name: 'CreatorIndex',
  components: { AiAssistant, AppView, AppDialog, Snackbar, ConfirmDialog },
  data () {
    return {
      dialogList: DialogList,
      confirmDialogList
    }
  }
})
